import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-canvas" data-id="element-128" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-129" data-mp="223elfl66t93g">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-black border border-gold/70 rounded-3xl p-8 md:p-12 text-center" data-id="element-130" data-mp="222db5iwzwqms">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full border-2 border-gold text-gold mb-8" data-id="element-131" data-mp="14h8tk5uw8gl2">
            <ShieldCheck size={44} aria-hidden="true" data-id="element-132" data-mp="1j6die5w71j25" />
          </div>
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-6 text-white" data-id="element-133" data-mp="1ec94t3sfacs3">
            Complete <span className="text-gold" data-id="element-134" data-mp="qmonsqftxplg">7-day guarantee</span>
          </h2>
          <div className="space-y-5 text-lg text-mist max-w-2xl mx-auto" data-id="element-135" data-mp="lo51goxbqbsk">
            <p data-id="element-136" data-mp="p01h478gp19q">
              Open the complete system. Explore all 6 volumes. Review all 5 bonuses. Use the
              material with your athletes.
            </p>
            <p className="text-white" data-id="element-137" data-mp="twi776z81ppg">
              If you feel the material is not clear, practical or useful for your coaching needs,
              contact us within 7 days according to the guarantee terms.
            </p>
            <p className="text-gold font-display font-bold text-2xl" data-id="element-138" data-mp="60xat68b1llr">7 days to decide.</p>
            <p className="text-sm text-steel" data-id="element-139" data-mp="azqr16ez7qpm">
              The goal is simple: you should feel that the system saves time and gives you material
              you can actually use.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}